import { hooks } from "./utils";

function ContextContainer({ children }) {
    return (
        <hooks.ProvideSolidColor>
            <hooks.ProvideGradientColor>
                <hooks.ProvideImagePicker>
                    <hooks.ProvidePopularColor>
                        {children}
                    </hooks.ProvidePopularColor>
                </hooks.ProvideImagePicker>
            </hooks.ProvideGradientColor>
        </hooks.ProvideSolidColor>
    )
}

export default ContextContainer;